import type { AxiosRequestConfig } from 'axios';
import api from '@/lib/api';
import type { SshKeyDto } from '@/api/hetzner';

/**
 * Fetch the SSH keys of a DigitalOcean account by token.
 * Backend endpoint: POST /rest/provider/digitalocean/sshkeys (404 while DigitalOcean is switched off)
 */
export async function getDigitalOceanSshKeys(
  providerAuthToken: string,
  config: AxiosRequestConfig = {}
): Promise<SshKeyDto[]> {
  const { data } = await api.post<SshKeyDto[]>(
    'provider/digitalocean/sshkeys',
    { providerAuthToken },
    config
  );
  return Array.isArray(data) ? data : [];
}
